<template>
    <div @click="$emit('click', $event)"
         class="rounded bg-grad-2 d-flex align-items-center justify-content-center"
         :style="{'min-width': width, 'min-height': height, 'height': height, 'width': width}"
    >
        <b-icon-file-earmark class="text-primary-design" scale="3"></b-icon-file-earmark>
    </div>
</template>

<script>
    export default {
        name: "ApplicationThumbnail",
        props: {
            height: {
                type: String,
                default: '6.25rem'
            },
            width: {
                type: String,
                default: '6.25rem'
            }
        }
    }
</script>

<style scoped>

</style>
